import { PlantsApi } from '../../../../core/api/plants/plants-api.service';
import { BaseForm } from '../../../../forms/forms/base.form';
import { Select } from '../../../../forms/forms/select-plants.form';
import { QuickHarvestFormControls } from '../form-controls/quick-harvest.form-controls';

export class QuickHarvestForm extends BaseForm<QuickHarvestFormControls> {
  formGroup = this.createFormGroup(QuickHarvestFormControls);

  plantsForm = new Select(this.plantsApi);

  constructor(private plantsApi: PlantsApi) {
    super();
  }

  override get isValid(): boolean {
    return super.isValid && this.plantsForm.isValid;
  }

  override get hasChanges(): boolean {
    return super.hasChanges || this.plantsForm.hasChanges;
  }
}
